export enum TaskType {
  DELIVERY = "Delivery",
  DISPATCH = "Dispatch",
  DROPOFF = "DropOff",
  GENERAL = "General",
  INVENTORY = "Inventory",
  LOCAL = "Local",
  PACK = "Pack",
  PICKUP = "Pickup",
  RECEIVAL = "Receival",
  RETRIEVAL = "Retrieval",
  TRANSSHIPMENT = "Transshipment",
  UPLIFT = "Uplift",
  VIDEO_SURVEY = "Video Survey",
  HOME_SURVEY = "Home Survey",
  QUOTE = "Quote",
  PREFERRED_UPLIFT = "Preferred Uplift",
  VEHICLE = "Vehicle",
  PET = "Pet",
  COLLECTION_DEBRIS = "Collection of Debris",
  PARKING_SIGNS_DESTINATION = "Parking signs at Destination",
  ASSISTANCE_ORIGIN = "Assistance at origin",
  COLLECTION_PAPERS_DEBRIS_ORIGIN = "Collection of papers and debris origin",
  DELIVERY_PACKING_MATRIALS_ORIGIN = "Delivery packing matrials at origin",
  DELIVERY_PAPERS_PACKING_MATRIALS_ORIGIN = "Delivery papers & packing matrials at origin",
  PICKUP_PARKING_SIGNS_ORIGIN = "Pick-up parking signs Origin",
  PLACING_PARKING_SIGNS__ORIGIN = "Placing parking signs Origin",
  PREMOVE_SURVEY = "Premove Survey",
  REPACK = "Repack",
  ROUNDTRIP = "Roundtrip",
  ASSISTANCE_DESTINATION = "Assistance Destination",
  ASSISTANCE_AT_DESTINATION = "Assistance at destination",
  COLLECTION_PAPERS_DEBRIS_DESTINATION = "Collection of papers and debris destination",
  OFFER = "Offer",
  DELIVERY_PAPERS_DESTINATION = "Delivery  papers at Destination",
  PICKUP_PARKING_SIGNS_DESTINATION = "Pick-up parking signs destination",
  PLACING_PARKING_SIGNS_DESTINATION = "Placing parking signs destination",
  ACCESS_CHECK_DESTINATION = "Access Check Destination",
  UNPACK = "Unpack",
}

export enum DatePeriodOptions {
  LAST_DAY = "lastDay",
  LAST_WEEK = "lastWeek",
  LAST_15_DAYS = "last15Days",
  LAST_MONTH = "lastMonth",
  CUSTOM_PERIOD = "customPeriod",
  CUSTOM_DATE = "customDate",
}

export enum OptionsSwitch {
  YES = "yes",
  NO = "no",
}

export enum InventoryLink {
  QUOTED = "Quoted",
  ACTUAL = "Actual",
}

export enum DateFilterTypes {
  Today = "today",
  Month = "monthly",
  Year = "yearly",
}

export enum ReportGroup {
  Business = "Business",
  Operations = "Operations",
  Warehousing = "Warehousing",
  Management = "Management",
}

export enum ReportSubGroup {
  Bookings = "Bookings",
  Orders = "Orders",
  Shipments = "Shipments",
  Products = "Products",
  Invoices = "Invoices",
  Financials = "Financials",
  Warehouses = "Warehouses",
  Management = "Management",
  Quotes = "Quotes",
}

export enum TokenType {
  EMAIL_VERIFICATION = "EV",
  PASSWORD_RESET = "PR",
  CONFIRM_STORAGE = "CS",
  CONFIRM_BOOKING = "CB",
  CONFIRM_QUOTE = "CQ",
  LOGIN_MOBILE = "LM",
  CONFIRM_ACCOUNTING_INVOICE = "AI",
  QUOTATION_COMPANY = "QC",
  CONFIRM_JOB = "CJ",
  LOGIN_WEB = "LW",
  EXTERNAL_REPORT = "ER",
}

export enum ExportReportType {
  PDF = "PDF",
  CSV = "CSV",
}

export enum ExportReportExtension {
  PDF = "pdf",
  ZIP = "zip",
  XLSX = "xlsx",
}

export enum TypeError {
  SUCCESS = "success",
  ERROR = "error",
  WARNING = "warning",
  INFO = "info",
  ERROR_WITHOUT_TOAST = "ERROR_WITHOUT_TOAST",
}

export enum OnboardingStage {
  INTRODUCTION = 1,
  COMPANY_DETAILS = 2,
  MY_BILLING = 3,
  MEMBERS = 4,
  UPLOAD_CENTRE = 5,
  COMPLETE = 6,
  FINISHED = 7,

  SHIPMENT_TRACKING_UPLOAD_CENTRE = 3, // mantém compatibilidade
  SHIPMENT_TRACKING_COMPLETE = 4,
  SHIPMENT_TRACKING_FINISHED = 5,
}

export enum CodeError {
  NOT_AVAILABLE = "NOT_AVAILABLE",
  STATUS_INACTIVE = "STATUS_INACTIVE",
  FORBIDDEN = "FORBIDDEN",
  UNKNOWN = "unknown",
  INVALID_CSV = "INVALID_CSV",
  THIS_PASSWORD_HAS_ALREADY_BEEN_USED = "THIS_PASSWORD_HAS_ALREADY_BEEN_USED",
}

export enum Mode {
  Sea = "Sea",
  Air = "Air",
  Road = "Road",
  Rail = "Rail",
  Warning = "Warning",
}

export enum TaskStatus {
  REGISTERED = "Registered",
  WAITING_PUBLISH = "Waiting Publish",
  PENDING_ACCEPT = "Pending Accept",
  ACCEPTED = "Accepted",
  STARTED = "Started",
  PENDING_APPROVE = "Pending Approve",
  FINISHED = "Finished",
  CANCELLED = "Cancelled",
  REJECTED = "Rejected",
  COMPLETED = "Completed",
  PUBLISHED = "Published",
  CREATED = "Created",
  IN_PROGRESS = "In Progress",
  DRAFT = "Draft",
  TO_DO = "To Do",
}

export enum CompanyProfile {
  SP = "SP",
  FM = "FM",
  MV = "MV",
  MA = "MA",
  ST = "ST",
  SPP = "SPP",
}

export enum FolderType {
  DOCUMENTS = "Documents",
  PHOTOS_VIDEOS = "Photos & Videos",
}

export enum FolderName {
  DOCUMENTS = "documents",
  PHOTOS = "photos",
  VIDEOS = "videos",
  GENERAL = "general",
  VIDEO_SURVEY = "Video Survey",
}

export enum DESTINATION {
  RESIDENCE = "Residence",
  NOT_GOING = "Not going",
  OPTIONAL = "Optional",
  STORE = "Store",
  AIR = "Air freight",
  SEA = "Sea freight",
  ROAD = "Road freight",
}

export enum MODE {
  Air = "Air",
  Road = "Road",
  Sea = "Sea",
}

export enum AvailableIn {
  BOTH = "Both",
  SALES = "Sales",
  OPS = "OPS",
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export enum ITEM_DESTINATION_COLOR {
  "Sea" = "rgb(9, 103, 204)",
  "Address2" = "rgb(202, 9, 204)",
  "Optional" = "rgb(232, 142, 39)",
  "Residence" = "#073763",
  "Not going" = "rgb(230, 3, 3)",
  "Air" = "rgb(9, 204, 203)",
  "Store" = "rgb(116, 132, 0)",
  "Road" = "rgb(74, 64, 4)",
  "None" = "rgb(0, 0, 0)",

  "Air freight" = "rgb(9, 204, 203)",
  "Sea freight" = "rgb(9, 103, 204)",
  "Road freight" = "rgb(74, 64, 4)",
}

export enum JobStatus {
  ADVISED = "Advised",
  ASSIGNED = "Assigned",
  BOOKED = "Booked",
  CANCELLED = "Cancelled",
  DELIVERED = "Delivered",
  FINISHED = "Finished",
  IN_PROGRESS = "In Progress",
  IN_TRANSIT = "In Transit",
  LEAD = "Lead",
  LOADED = "Loaded",
  LOST = "Lost",
  PACKED = "Packed",
  QUOTE = "Quote",
  QUOTED = "Quoted",
  STARTED = "Started",
  UNLOADED = "Unloaded",
  LATE = "Late",
  TRIP = "Trip",
  REVIEW = "Review",
  RECEIVED = "Received",
  TRANSSHIPPED = "Transshipped",
}

export enum JobType {
  EXPORT = "Export",
  IMPORT = "Import",
  STORAGE = "Storage",
  TOLL = "Toll",
  FINE_ART = "Fine Art",
  BUSINESS_SERVICE = "Business Service",
  INTERSTATE_JOBS = "Interstate Jobs",
  LOCAL = "Local",
  COUNTRY_REMOVAL = "Country Removal",
  LONG_DISTANCE = "Long Distance",
  STORE_OUT = "Store Out",
  GBS = "Business Service",
  INTERSTATE = "Interstate",
}

export enum JobSubStatus {
  OPEN = "Open",
  BOOKED = "Booked",
  ACCEPTED = "Accepted",
  CANCELLED = "Cancelled",
  INSPECT = "Inspect",
  PENDING = "Pending",
  DRAFT = "Draft",
  WON = "Won",
  WON_DRAFT = "Won (Draft)",
  LOST = "Lost",
  ESTIMATE_APPROVED = "Estimate Approved",
}

export enum SettingsNavItems {
  COMPANY = "company",
  GENERAL = "general",
  PEOPLE = "people",
  RESOURCES = "resources",
  CONFIGURATIONS = "configurations",
  INTEGRATIONS = "integrations",
  BILLING = "billing",
  HISTORY = "history",
  INVENTORY = "inventory",
  USERS = "users",
  ROLES = "roles",
  CHECKLIST = "checklist",
  FLEET = "fleet",
  ITEM = "item",
  LOCATION = "location",
  PACKAGING = "packaging",
  PREPARATION = "preparation",
  MODE = "mode",
  EXCEPTION = "exception_codes",
  EXCEPTION_LOCATION = "exception_location",
  SPECIAL_INSTRUCTIONS = "special_instructions",
  DESTINATION = "destination",
  COMMUNICATION_CENTRE = "communication_centre",
}

export enum CompanyProfileInitial {
  FM = "FM",
  SP = "SP",
  MV = "MV",
}

export enum Status {
  ACTIVE = "Active",
  INACTIVE = "Inactive",
  PENDING_ACCEPTANCE = "Pending Accept",
}
export enum ContactType {
  PRIMARY = "Primary",
  SECONDARY = "Secondary",
  BILLING = "Billing",
  OPERATIONS = "Opeartions",
}
export enum EquipmentType {
  FLEET = "Fleet",
  GENERAL = "General",
}
export enum EquipmentOwnership {
  OWN = "Own",
  SUBCONTRACTOR = "Subcontractor",
  RENTAL = "Rental",
  LEASED = "Leased",
}

export enum UserStatus {
  ACTIVE = "Active",
  INACTIVE = "Inactive",
  REJECTED = "Rejected",
  INVITATION_SENT = "Invitation sent",
  INVITE_EXPIRED = "Invite expired",
  REVOKED = "Revoked",
}

export enum AgentStatus {
  ACTIVE = "Active",
  DISABLED = "Disabled",
  REJECTED = "Rejected",
  INVITATION_SENT = "Invitation sent",
  INVITATION_EXPIRED = "Invitation expired",
  REVOKED = "Revoked",
}

export enum StorageStatus {
  LOADED = "Loaded",
  EMPTY = "Empty",
  FULL = "Full",
}

export enum LocationStatus {
  EMPTY = "Empty",
  IN_USE = "In Use",
}

export enum TypeReportWarehouse {
  LOCATION_STATUS = "LOCATION_STATUS",
  MOVEMENTS = "MOVEMENTS",
}

export enum UserTypes {
  USER = "User",
  ADMIN = "Admin",
  STAFF = "Staff",
  OPERATIONS = "Operations",
  SALES = "Sales",
  WAREHOUSE = "CFS Operator",
  DRIVER = "Driver",
  MOVING_WAREHOUSE = "Warehouse",
  AGENT = "Agent",
}

export enum RoleType {
  CUSTOM = "Custom",
  SYSTEM = "System",
}

export enum GroupType {
  CUSTOM = "Custom",
  SYSTEM = "System",
}

export enum TaskAutoSuggestInputType {
  MEMBER = "member",
  STAFF = "staff",
  FLEET = "fleet",
}

export enum MeasurementTypes {
  DIMENSIONS = "Dimensions",
  WEIGHT = "Weight",
}

export enum FleetConditional {
  NEW = "New",
  USED = "Used",
}

export enum InvoiceStatus {
  DRAFT = "draft",
  OPEN = "open",
  VOID = "void",
  PAID = "paid",
  UNCOLLECTIBLE = "uncollectible",
}

export enum FleetFuelTypes {
  DIESEL = "Diesel",
  GASOLINE = "Gasoline",
  ETHANOL = "Ethanol",
  LPG = "LPG",
  PETROL = "Petrol",
}

export enum FleetTypeMode {
  PANTECH = "Pantech",
  FLATBED = "Flatbed",
}

export enum FleetOwnership {
  FULLY_OWNED = "Fully Owned",
  LEASING = "Leasing",
}

export enum Gender {
  MALE = "Male",
  FEMALE = "Female",
}

export enum InstructionWhen {
  UPLIFT = "Uplift",
  DELIVERY = "Delivery",
  COORDINATOR = "Move Coordinator",
}

export enum SubStatusUsedBy {
  ESTIMATES = "Estimates",
  ORDERS = "Orders",
}

export enum DisassemblyOptions {
  REMOVALIST = "Removalist",
  CUSTOMER = "Customer",
}

export enum SymbolType {
  DESCRIPTIVE = "Descriptive",
  EXCEPTION = "Exception",
  LOCATION = "Location",
}

export enum AutomaticSequenceOptions {
  ORDER = "Order",
  OPERATIONS = "Operations",
  QUOTE = "Quote",
  TRIP = "Trip",
  CUSTOMER = "Customer",
  TRANSSHIPMENT = "Transshipment",
  SHIPMENT = "Shipment",
  USER = "User",
  AGENT = "Agent",
  INVOICE_NUMBER = "Invoice Number",
}

export enum TypeAccess {
  DRIVEWAY = "Driveway",
  DRIVEWAY_LENGTH = "Driveway Length",
  PARKING = "Parking",
  CARRY_DISTANCE = "Carry Distance",
  ACTION = "Action",
}

export enum UsedByStatuses {
  QUOTES = "Quotes",
  ORDERS = "Orders",
}

export enum MeasurementType {
  DIMENSION = "Dimensions",
  WEIGHT = "Weight",
}

export enum CustomerType {
  PRIVATE = "Private",
  CORPORATE = "Corporate",
}

export enum ChargeOptionsEnum {
  FEE = "Fee",
  FLAT = "Flat",
  HALF_HOUR = "Half Hour",
  HOURLY = "Hourly",
}

export enum UploadValueType {
  UPLOAD_VALUE_OWN_LIST = "uploadOwnList",
  UPLOAD_VALUE_SHIPEEZI_LIST = "shipeeziDefaultList",
}

export enum InventoryUploadCSVType {
  ITEMS = "Items",
  EXCEPTION = "Exception",
  EXCEPTION_LOCATION = "Exception Location",
  PREPARATION_METHOD = "Preparation Method",
  LOCATION = "Location",
  PACKAGE_TYPE = "Package Type",
  MODE = "Mode",
}

export enum UploadCSVType {
  INVENTORY_LIST = "inventoryList",
  INVENTORY_LOCATION = "inventoryLocation",
  INVENTORY_PACKAGE_TYPE = "inventoryPackageType",
  INVENTORY_PREPARATION_METHOD = "inventoryPreparationMethod",
  INVENTORY_MODE = "inventoryMode",
  INVENTORY_EXCEPTION = "inventoryException",
  INVENTORY_EXCEPTION_LOCATION = "inventoryExceptionLocation",
  FLEET = "fleet",
  SERVICES = "services",
  INSTRUCTIONS = "instructions",
  MATERIALS = "materials",
  STAFF = "staff",
  ACCESS = "access",
  SHIPMENT = "shipment",
}

export enum Routes {
  ON_BOARDING = "onboarding",
  PROFILE = "profile",
  BILLING = "billing",
  NOTIFICATIONS = "notifications",
  USERS = "users",
  SETTINGS = "settings",
  SIGNIN = "signin",
  FORGOT = "forgot",
  UPDATE_PASSWORD = "update-password",
  APPROVE_COMPANY_TEMPORARY = "settings/approve",
  ACCEPT_INVITE = "accept-invite",
  PRIVACY_POLICY = "privacypolicy",
  ESTIMATE_QUOTE = "estimate",
  STORAGE_ACCOUNTS = "storage-accounts",
  STORAGE_BOX_AND_UNIT = "storage-boxes-units",
  ROUTE_PLANNER = "route-planner",
  CUSTOMER_PORTAL = "customer-portal",
}

export enum ResourceGroup {
  OPERATION = "Operation",
  SALES = "Sales",
  BUSINESS = "Business",
  OPERATIONS = "Operations",
  VIDEO_CALL = "VideoCall",
  DISPATCH = "Dispatch",
  CONTAINERS = "Containers",
  SHIPMENTS = "Shipments",
  SHIPMENT_TRACKING = "Shipment tracking",
  BILLING = "Billing",
  ORDERS = "Orders",
  WAREHOUSING = "Warehousing",
  MANAGEMENT = "Management",
}

export enum ResourceName {
  ANALYTICS = "Analytics",
  ORDERS = "Orders",
  BUSINESS = "Business",
  OPERATIONS = "Operations",
  QUOTE = "Quote",
  DESPATCHES = "Despatches",
  VIDEO_CALL = "VideoCall",
  DISPATCH = "Dispatch",
  CONTAINERS = "Containers",
  SHIPMENTS = "Shipments",
  SHIPMENT_TRACKING = "Shipment tracking",
  PRODUCTS = "Products",
  BOOKING = "Booking",
  SEARCH_FREIGHT = "Search freight",
  TRANSSHIPMENT = "Transshipment",
  STORAGE_ACCOUNTS = "Storage Accounts",
  STORAGE_BOX_AND_UNIT = "Storage Box And Unit",
  MOVEMENT = "Movement",
  MANAGEMENT = "Management",
  MEMBERS = "Members",
  SUBCONTRACTORS = "Subcontractors",
  EQUIPMENTS = "Equipments",
}

export enum ResourceSubGroup {
  ORDERS = "Orders",
  SALES = "Sales",
  VIDEO_CALL = "VideoCall",
  DISPATCH = "Dispatch",
  CONTAINERS = "Containers",
  OPERATIONS = "Operations",
  SHIPMENTS = "Shipments",
  SHIPMENT_TRACKING = "Shipment tracking",
  BUSINESS = "Business",
  BOOKING = "Booking",
  WAREHOUSING = "Warehousing",
  MANAGEMENT = "Management",
}

export enum SpecialInstructionsTypes {
  CRATE = "Crate",
  DISASSEMBLY = "Disassembly",
}

export enum ItemType {
  REMOVALS = "Removals",
  COMMERCIAL = "Commercial",
}

export enum LocationType {
  ORIGIN = "Origin",
  DESTINATION = "Destination",
}

export enum TreesPowerLineType {
  LOW = "Low",
  OVERHANGING = "Overhanging",
}

export enum QuestionBooleanType {
  YES = "yes",
  NO = "no",
}

export enum OrderProductStatus {
  SCANNED = "Scanned",
  TO_BE_PICKED = "To be picked",
}

export enum OrderTitleStatus {
  NEW = "NEW",
}

export enum OrderFilterKeys {
  SHIP_BY_DATE = "shipByDate",
}

export enum OrderStatus {
  RECEIVED = "received",
  FULFILLED = "fulfilled",
  CANCELLED = "cancelled",
  CLOSED_FOR_RECEIVING = "closedForReceiving",
  CLOSED_FOR_INVOICING = "closedForInvoicing",
  READY_TO_SHIP = "readyToShip",
  LOADED = "loaded",
  PARTLY_LOADED = "Partly Loaded",
  ASSIGNED = "assigned",
  CONFIRMED = "confirmed",
}

export enum ReportLanguage {
  ENGLISH = "English",
}

export enum OrderShipByDate {
  PAST_SHIP_BY_DATE = "pastShipByDate",
}
export const OrderStatusAvailableToAdd = [
  OrderStatus.RECEIVED,
  OrderStatus.FULFILLED,
  OrderStatus.CLOSED_FOR_RECEIVING,
  OrderStatus.CLOSED_FOR_INVOICING,
  OrderStatus.READY_TO_SHIP,
  OrderStatus.LOADED,
];

export enum PaymentOption {
  ACCOUNT = "account",
  CREDIT_CARD = "credit_card",
  CASH = "cash",
}

export enum VideoStatus {
  DELETED = "Deleted",
}

export enum OrderType {
  PURCHASE = "Purchase Order",
  SALES = "Sales Order",
}

export enum PerformancePredictionType {
  AS_PLANNED = "As Planned",
  POTENTIAL_DELAY = "Potential Delay",
  DELAYED = "Delayed",
}

export enum ShipmentType {
  AIR = "Air",
  RAIL = "Rail",
  ROAD = "Road",
  SEA = "Sea",
}

export enum OrderModeType {
  SEA = "SEA",
  AIR = "AIR",
  ROAD = "ROAD",
}

export enum ShipmentStatus {
  PLANNED = "planned",
  BOOKED = "booked",
  STAGED = "staged",
  LOADED = "loaded",
  IN_TRANSIT = "in transit",
  DELIVERED = "delivered",
  WAITING_FOR_UPDATE = "Waiting for update",
  DELETED = "Deleted",
  COMPLETED = "Shipment Completed",
  DRAFT = "Draft",
  TRACKING_NOT_AVAILABLE = "Tracking not available",
  CANCELLED = "Cancelled",
  SHIPPED = "Shipped",
}

export enum ShipmentTrackingStatus {
  ARRIVAL_AT_TRANSHIPMENT_PORT = "arrival at transhipment port",
  ARRIVED_AT_PORT_OR_DISCHARGE = "arrived at port or discharge",
  BOOKED = "booked",
  COLLECTED_FROM_SHIPPER = "collected from shipper",
  DRAFT = "draft",
  LEFT_THE_DESTINATION_PORT = "left the destination port",
  NOT_ARRIVED_AT_PORT_OF_LOAD = "not arrived at port of load",
  SHIPMENT_COMPLETED = "shipment completed",
  SHIPPED_ON_BOARD = "shipped on board",
  SHIPPED_ON_BOARD_AT_TRANSHIPMENT_PORT = "shipped on board at transhipment port",
  TRACKING_NOT_AVAILABLE = "tracking not available",
  UNDERWAY = "underway",
  UNDERWAY_TO_A_TRANSHIPMENT_PORT = "underway to a transhipment port",
  WAITING_AT_DESTINATION_PORT = "waiting at destination port",
  WAITING_AT_PORT_OF_LOAD = "waiting at port of load",
  WAITING_AT_TRANSHIPMENT_PORT = "waiting at transhipment port",
  WAITING_FOR_UPDATE = "waiting for update",
}

export enum ModifiedShipmentTrackingStatus {
  ARRIVED_AT_PORT_OF_DISCHARGE = "Arrived at Port of discharge",
  WAITING_AT_PORT_OF_DISCHARGE = "Waiting at port of Discharge",
  DEPARTED_FROM_PORT_OF_DISCHARGE = "Departed from port of Discharge",
}

export enum Incoterm {
  CPT = "CPT",
  CIP = "CIP",
  CFR = "CFR",
  CIF = "CIF",
  FCA = "FCA",
  FOB = "FOB",
  DAP = "DAP",
  DDP = "DDP",
  DPU = "DPU",
  EXW = "EXW",
  FAS = "FAS",
}

export enum ServiceType {
  FCL = "FCL",
  LCL = "LCL",
}

export enum QuantityUnitType {
  UNT = "UNT",
  PKG = "PKG",
}

export enum BookingModes {
  SEA = "Sea",
  AIR = "Air",
  ROAD = "Road",
}

export enum ShareType {
  SMS = "sms",
  EMAIL = "email",
}

export enum BookingStatus {
  CANCELLED = "cancelled",
  PENDING = "pending",
  CONFIRMED = "confirmed",
  REJECTED = "rejected",
  SUBMITTED = "submitted",
  PARTIALLY_DELIVERED = "partially delivered",
  DELIVERED = "delivered",
  CFS_REVIEW = "cfs review",
  UNDER_REVIEW = "under review",
  CFS_RECEIVED = "cfs received",
  RECEIVED = "received",
}

export enum CartonStatus {
  RECEIVED = "received",
  NOT_RECEIVED = "notReceived",
  CLOSED = "closed",
  OPEN = "open",
}

export enum ItemJobStatus {
  DELIVERED = "Delivered",
  REGISTERED = "Registered",
  LOADED = "Loaded",
  TAKEN = "Taken",
  VOID = "Void",
  VOIDED = "Voided",
  DISPOSAL = "Disposal",
  MISSING = "Missing",
  SHIPPED = "Shipped",
  PACKED = "Packed",
  UPLIFTED = "Uplifted",
  BOL = "BOL",
  TRANSSHIPPED = "Transshipped",
  NOT_SIGHTED = "Not Sighted",
}

export enum ItemJobSubStatus {
  ACTUAL = "Actual",
  QUOTED = "Quoted",
}

export enum Report {
  MECHANICAL_ELECTRICAL_CHECKLIST = "Mechanical & Electrical checklist",
  RISK_ASSESSMENT = "Risk Assessment",
  INVENTORY_CONDITION = "Inventory Condition Report",
}

export enum ChecklistType {
  GENERAL = "General",
  RISK_ASSESSMENT = "Risk Assessment",
  CUSTOMER_SURVEY = "Customer Survey",
  STATEMENT_OF_ASP = "Statement Of Accessorial Services Performed",
}

export enum NotificationCentrePage {
  EMAIL = "Email",
  SMS = "SMS",
}

export enum TemplateTypeOptions {
  CUSTOMER = "customer",
  QUOTE = "quote",
  ORDER = "order",
  VIDEO_SURVEY = "videoSurvey",
  GENERAL = "general",
}

export enum TemplateTypeLabels {
  CUSTOMER = "Customer",
  QUOTE = "Quote",
  ORDER = "Order",
  VIDEO_SURVEY = "Video Survey",
  GENERAL = "General",
  ASSIGNED_TO_MANAGER = "Assigned to Manager",
}

export enum ContainerSizeType {
  ODD_SIZED_CONTAINER = "Odd sized container",
  REGULAR_SIZE_CARGO = "Regular sized cargo",
  REEFER_CONTAINER = "Reefer container",
}

export enum CommunicationsFromOptions {
  EMAIL = "email",
  SMS = "sms",
  BOTH = "both",
  EMPTY = "empty",
}

export enum NotificationsTypes {
  WEB = "web",
  MOBILE = "mobile",
  SMS = "sms",
}

export enum PushNotificationTarget {
  WEB = "shipeezi-web",
  OPERATIONS_APP = "shipeezi-ops",
  SALES_APP = "shipeezi-sales",
}

export enum ShipmentAgentType {
  ORIGIN = "origin",
  DESTINATION = "destination",
}

export enum ExtraCheckValues {
  MODE = "mode",
  ORIGIN_PORT = "loadingPort",
  DISCHARGE_PORT = "dischargePort",
}

export enum ExtraCheckKeys {
  MODE = "mode",
  ORIGIN_PORT = "originPortId",
  DESTINATION_PORT = "destinationPortId",
}

export enum DocumentAvailableAutoGenerate {
  COMMERCIAL_INVOICE_PACKING_LIST = "Commercial Invoice and Packing List",
}

export enum NotificationAction {
  IMPORTANT = "important",
  READ = "read",
  ALL_READ = "allRead",
  IMPORTANT_FROM_DROPDOWN = "importantFromDropdown",
  READ_FROM_DROPDOWN = "readFromDropdown",
  ALL_READ_FROM_DROPDOWN = "allReadFromDropdown",
}

export enum NotificationResourceName {
  QUOTE = "quote",
  ORDER = "order",
}

export enum NotificationTriggerTypeOptions {
  QUOTE = "quote",
  ORDER = "order",
  VIDEO_SURVEY = "video survey",
}

export enum TriggerGroupOptions {
  QUOTE = "quote",
  ORDER = "order",
  CUSTOMER = "customer",
  COMPANY = "company",
  SHIPMENT = "shipment",
}

export enum LanguagesUsage {
  WEB = "Web",
  APP = "App",
}

export enum ApplicationType {
  WEB = "web",
  OPERATIONS = "operations",
  SALES = "sales",
  WAREHOUSE = "warehouse",
  EMAIL = "email",
}

export enum TaskTypeRole {
  OPERATIONS = "Operations",
  GENERAL = "General",
}

export enum DocumentCustomerPortal {
  MISSING = "missing",
  MISSING_SHIPMENT = "missingShipment",
  UPLOADED = "uploaded",
  CANCELLED = "cancelled",
}

export enum JobDocumentPortalStatus {
  SHARED = "shared",
  REQUESTED = "requested",
  MISSING = "missing",
  MISSING_SHIPMENT = "missingShipment",
  REVIEW = "review",
  APPROVED = "approved",
  REJECTED = "rejected",
  UPLOADED = "uploaded",
}

export enum CountryCode {
  BANGLADESH = "BD",
  BRAZIL = "BR",
  INDIA = "IN",
  CAMBODIA = "KH",
  INDONESIA = "ID",
  PAKISTAN = "PK",
  UNITED_KINGDOM = "GB",
}

export enum CountryName {
  BANGLADESH = "Bangladesh",
  INDIA = "India",
  CAMBODIA = "Cambodia",
  INDONESIA = "Indonesia",
  PAKISTAN = "Pakistan",
}

export enum Step {
  FIRST = 0,
  SECOND = 1,
  THIRD = 2,
  FOURTH = 3,
  FIFTH = 4,
  SIXTH = 5,
}

export const TOTAL_STEPS = 6 as const;
export const isStep = (n: number): n is Step => n >= Step.FIRST && n <= Step.SIXTH;

export enum EstimatedQuoteStatus {
  DECLINED = "Declined",
  APPROVED = "Approved",
  IN_REVIEW = "In Review",
}

export enum NotificationTagStatus {
  DECLINED = "Declined",
  APPROVED = "Approved",
  CANCELLED = "Cancelled",
  UPDATED = "Updated",
  NEW = "New",
}

export enum TransshipmentSearchType {
  ORDER = "Order",
  FLEET = "Fleet",
  STORAGE_BOX = "Storage Box",
  LOCATION = "Location",
}

export enum TransshipmentWhatToDo {
  LOAD = "Load",
  UNLOAD = "Unload",
}
export enum TransshipmentWhereToLoad {
  FLEET = "Fleet",
  STORAGE_BOX = "Storage box",
  STORAGE_BOX_SINGLE_USE = "Storage box single use",
}

export enum FileType {
  VIDEO = "video",
  IMAGE = "image",
  PDF = "pdf",
}

export enum ShareOptions {
  SHARE_ESTIMATE_LINK = "shareEstimateLink",
  SHARE_EMAIL = "shareEmail",
  SHARE_SMS = "shareSMS",
  SHARE_SMS_OR_EMAIL = "shareSMSOrEmail",
  SHARE_CUSTOMER_PORTAL_LINK = "shareCustomerPortalLink",
  SHARE_PUSH_NOTIFICATION = "sharePushNotification",
  SHARE_VIDEO_SURVEY_LINK = "shareVideoSurveyLink",
}

export enum UsedInEmailTemplates {
  ORDERS = "Order",
  QUOTES = "Estimate",
  SHIPMENTS = "Shipment",
}

export enum DespatchesDetailsFields {
  STATUS = "status",
  ORIGINS = "origins",
  DESTINATIONS = "destinations",
}

export enum DespatchesProductsFields {
  PRODUCTS = "products",
}

export enum DespatchesShippingItemsFields {
  PRODUCTS = "shippingItems",
}

export enum DespatchesTruckFields {
  BOOKING_NUMBER = "bookingNumber",
  DELIVERY_DATE = "deliveryDate",
  DELIVERY_WINDOW_CLOSE = "deliveryWindowClose",
  DELIVERY_WINDOW_OPEN = "deliveryWindowOpen",
  FLEET_TYPE = "fleetType",
  PALLETS_PER_FLEET = "palletsPerFleet",
}

export type DespatchFields = DespatchesDetailsFields;

export enum ShipmentDetails {
  CONTAINER = "container",
  CONTAINER_ID = "containerId",
  CONTAINERS = "containers",
  SIZE = "size",
  SEAL = "seal",
  GROSS_WEIGHT = "grossWeight",
  PORT_OF_LOADING_ID = "portOfLoadingId",
  PORT_OF_DISCHARGE_ID = "portOfDischargeId",
  PORT_OF_RECEIPT_ID = "portOfReceiptId",
  PORT_OF_DESTINATION_ID = "portOfDestinationId",
  ORIGIN = "origin",
  DESTINATION = "destination",
  PLANE = "plane",
  JOURNEY = "journey",
  AIRWAY_BILL = "airwayBill",
  VESSEL_NAME = "vesselName",
  VOYAGE_NUMBER = "voyageNumber",
  MBL = "mbl",
  HBL = "hbl",
  SHIPMENT_TYPE = "shipmentType",
  ASN = "asn",
  CARGO_READY_DATE = "cargoReadyDate",
  CONSIGNEE_ID = "consigneeId",
  CONSIGNEE_CODE = "consigneeCode",
  DELIVER_TO = "deliverTo",
  CARRIER = "carrier",
  SERVICE_TYPE = "serviceType",
  PURCHASE_ORDERS = "purchaseOrders",
  SHIP_TERMS = "shipTerms",
  BOUND = "bound",
  OFFICE_ID = "officeId",
  NOTIFY_PARTY_ID = "notifyPartyId",
  STATUS_SHIPMENT = "statusShipment",
  COMMODITY_HS_CODE_ID = "commodityCodeId",
  COMMODITY = "commodity",
  COMMODITY_CODE = "commodityCode",
  INCOTERM = "incoterm",
  BILL_OF_LANDING = "billOfLanding",
  MASTER_BILL = "mbl",
  HOUSE_BILL = "hbl",
  BOOKING_NO = "bookingNo",
  SUPPLIER_ID = "supplierId",
  PROJECT_ID = "projectId",
  CARRIER_ID = "carrierId",
  LOAD_TYPE = "loadType",
  CARRIER_SCAC = "carrierScac",
  EVENT_TYPE = "eventType",
  CONTAINER_NUMBERS = "containerNumbers",
  ORIGIN_LOCATION = "originLocation",
  DESTINATION_LOCATION = "destinationLocation",
  PORT_OF_LOADING = "portOfLoading",
  PORT_OF_DISCHARGE = "portOfDischarge",
  AIRLINE = "airline",
  FLIGHT_NUMBER = "flightNumber",
  SHIPPER_ENTITY = "shipperEntity",
}

export enum ShipmentContainerInfoDetails {
  CONTAINER = "container",
  SIZE = "size",
  SEAL = "seal",
  GROSS_WEIGHT = "grossWeight",
  NET_WEIGHT = "netWeight",
  TARE_WEIGHT = "tareWeight",
  VOLUMETRIC_WEIGHT = "volumetricWeight",
  GROSS_VOLUME = "grossVolume",
  VERIFIED_GROSS_WEIGHT = "verifiedGrossWeight",
}

export enum CommercialInvoice {
  INVOICE_NUMBER = "invoiceNumber",
  BENEFICIARY_NAME = "beneficiaryName",
  BENEFICIARY_ADDRESS = "beneficiaryAddress",
  EXPORTER_NAME = "exporterName",
  EXPORTER_CONTACT_DETAILS = "exporterContactDetails",
  PAYMENT_TERMS = "paymentTerms",
  FISCAL_AGENT_DETAILS = "fiscalAgentDetails",
  SALES_CONTRACT_NUMBER = "salesContractNumber",
  SALES_CONTRACT_DATE = "salesContractDate",
  EXP_NUMBER = "expNumber",
  EXP_DATE = "expDate",
  // Bangladesh fields
  BANK_NAME = "bankName",
  BANK_ADDRESS = "bankAddress",
  ACCOUNT_NUMBER = "accountNumber",
  SWIFT_CODE = "swiftCode",
  TERMS_OF_DELIVERY = "termsOfDelivery",
  UD_NUMBER = "udNumber",
  ERC_NUMBER = "ercNumber",
  REX_NUMBER = "rexNumber",
  COUNTRY_ID = "countryId",
  VENDOR_ID = "vendorId",
}

export enum OrderDetailsFields {
  PROJECT_ID = "projectId",
  PERFORMANCE_PREDICTION = "performancePrediction",
  ORIGIN = "origin",
  DESTINATION = "destination",
  BE_CODE = "beCode",
  REFERENCE = "reference",
  TYPE = "type",
  DATE = "date",
  ORIGIN_PORT_ID = "originPortId",
  DESTINATION_PORT_ID = "destinationPortId",
  SHIP_VIA = "shipVia",
  PURCHASING_ORGANISATION = "purchasingOrganisation",
  CONSIGNEE = "consignee",
  SUPPLIER = "supplier",
  SERVICE_TYPE = "serviceType",
  SHIP_TO = "shipTo",
  CLIENT_CODE = "clientCode",
  REMARK = "remark",
  ADDRESS_CODE = "addressCode",
  DIVISION_CODE = "divisionCode",
  DIVISION_DESCRIPTION = "divisionDescription",
  DEPARTMENT_CODE = "departmentCode",
  DEPARTMENT_DESCRIPTION = "departmentDescription",
  INCOTERM = "incoterm",
  MODE = "mode",
  ETA = "eta",
  CURRENT_ETA = "currentEta",
  DELIVERY = "delivery",
  SUPPLIER_NAME = "supplierName",
  FOB_PRICE = "fobPrice",
}

export enum SearchProducts {
  REFERENCE = "reference",
  STATUS = "status",
  DESCRIPTION = "description",
  COLOR_DESCRIPTION = "colorDescription",
}

export enum LocationTypes {
  MAIN = "main",
  DELIVERY = "delivery",
}

export enum CalledFrom {
  CUSTOMER = "customer",
}

export enum DespatchStatus {
  PLANNED = "Planned",
  BOOKED = "Booked",
  STAGED = "Staged",
  LOADED = "Loaded",
  IN_TRANSIT = "In transit",
  DELIVERED = "Delivered",
}

export enum AddressTypeKeys {
  ORIGIN_ADDRESS = "origins",
  DESTINATION_ADDRESS = "destinations",
}

export enum DespatchContainerStatus {
  AVAILABLE = "available",
  ALL_DESPATCHED = "allDespatched",
  SELECTED = "selected",
}

export enum CronjobHistoryType {
  SENT = "sent",
}

export enum CronjobStatus {
  COMPLETED = "completed",
  ACTIVE = "active",
  DEACTIVATED = "deactivated",
}

export enum CronjobFrequency {
  ONCE = "once",
  DAILY = "daily",
  WEEKLY = "weekly",
  MONTHLY = "monthly",
}

export enum CronJobType {
  LCR_REPORT = "lcr-report",
  SHIPMENT_COST_REPORT = "shipment-cost-report",

  RECEIVED_BOOKINGS = "Received Bookings",
  RECEIVED_BY_CFS_BOOKINGS = "Received by CFS bookings",
  SKUS_BY_BOOKING = "SKU's by booking",

  PO_BY_SHIP_BY_DATE = "PO by Ship by date",
  PO_PER_STATUS = "PO per status",
  DAILY_INVOICE_REPORT = "daily-invoice-report",

  STOCK = "stock",
  STOCK_ON_HAND = "stock-on-hand",
  STOCK_ON_HAND_DETAILED = "stock-on-hand-detailed",

  REPORT = "report",
  CROSS_DOCK_STATUS = "crossdock",
  ORDER_AND_TASK_REPORT = "order-and-task-report",
}

export enum ReportName {
  LCR_REPORT = "COG LCR Report",
  SHIPMENT_COST_REPORT = "Shipment Costs",

  RECEIVED_BOOKINGS = "Received Bookings",
  RECEIVED_BY_CFS_BOOKINGS = "Received by CFS bookings",
  SKUS_BY_BOOKING = "SKU's by booking",

  PO_BY_SHIP_BY_DATE = "PO by Ship by date",
  PO_PER_STATUS = "PO per status",
  DAILY_INVOICE_REPORT = "Daily Invoice Report",

  STOCK = "Stock",
  STOCK_ON_HAND = "Stock On Hand",
  STOCK_ON_HAND_DETAILED = "Stock On Hand Detailed",

  REPORT = "Report",
  CROSS_DOCK_STATUS = "Cross Dock Status",

  LOCATION_STATUS = "Location Status",
  MOVEMENTS = "Movements",

  LOAD_REPORT = "Load & Transshipment Report",
  INVENTORY_CONDITION = "Inventory Condition Report",
  MECHANICAL_ELECTRICAL_CHECKLIST = "Mechanical & Electrical checklist",
  OUTTURN_REPORT = "Outturn Report",
  HIGH_RISK_HIGH_VALUE = "High Risk/High Value Inventory",
  PROPERTY_DAMAGE_REPORT = "Property Damage Report",
  PROPERTY_DAMAGE = "Property Damage Report",

  ORDER_AND_TASK_USAGE_REPORT = "Order and Task usage report",
  ORDER_REPORT = "Order Report",
  COSTING_REPORT = "Costing report",

  ORDER_SUMMARY_REPORT = "Order Summary",
  ALL_REPORTS = "All reports",
  WORK_ORDER = "Work Order",

  ORDER_BY_STATUS = "Orders by status",
  ORDER_BY_ASSIGN_LEADER = "Orders by assigned leader",

  SURVEY_REPORT = "Survey Report",
}

export enum LoadReportGroupBy {
  LIST = "LIST", // sorted by inventory
  LOADED_INTO = "LOADED_INTO", // sorted by storage box
}

export enum WeekDays {
  SUNDAY = "sunday",
  MONDAY = "monday",
  TUESDAY = "tuesday",
  WEDNESDAY = "wednesday",
  THURSDAY = "thursday",
  FRIDAY = "friday",
  SATURDAY = "saturday",
}

export enum WeekDayInitials {
  SUNDAY = "S",
  MONDAY = "M",
  TUESDAY = "T",
  WEDNESDAY = "W",
  THURSDAY = "T",
  FRIDAY = "F",
  SATURDAY = "S",
}

export enum FileTypes {
  CSV = "csv",
  PDF = "pdf",
  XLSX = "xlsx",
}
export enum ItemMEAttribute {
  DONE = "meDone",
  WORKING = "meWorking",
  DONE_DELIVERY = "meDoneDelivery",
  WORKING_DELIVERY = "meWorkingDelivery",
}

export enum ActualInventoryChecklistTabFields {
  ORIGIN = "origin",
  DESTINATION = "destination",
  DONE_FIELD = "done",
  WORKING_FIELD = "working",
}

export enum DefaultDateOptionsColumn {
  DATE = "date",
  DATE_RANGE = "dateRange",
}

export enum RangeDateOptions {
  START_DATE = "startDate",
  END_DATE = "endDate",
}

export enum MapStatus {
  INACTIVE = "Inactive",
  EMPTY = "Empty",
  LOADED = "Loaded",
  MIXED = "Mixed",
  SELECTED = "Selected",
}

export enum LanguageDefault {
  AU = "AU",
}

export enum Months {
  JANUARY = "january",
  FEBRUARY = "february",
  MARCH = "march",
  APRIL = "april",
  MAY = "may",
  JUNE = "june",
  JULY = "july",
  AUGUST = "august",
  SEPTEMBER = "september",
  OCTOBER = "october",
  NOVEMBER = "november",
  DECEMBER = "december",
}

export enum CrossDockStatus {
  NOT_RECEIVED = "NotReceived",
  RECEIVED_EXPECTED = "Received",
  RECEIVED_UNEXPECTED = "Unexpected",
}

export enum ProductStatus {
  IN_STOCK = "In Stock",
  OUT_OF_STOCK = "Out of Stock",
  CONFIRMED = "Confirmed",
  ACTIVE = "Active",
  INACTIVE = "Inactive",
}

export enum TransshipmentStatus {
  PLANNED = "Planned",
  UNPLANNED = "Unplanned",
}

export enum CartonEventType {
  PICK_UP = "Pick up",
}

export enum Currencies {
  AUD = "AUD",
  USD = "USD",
}

export enum ContainerModes {
  AIR = "AIR",
  FCL = "FCL",
  FCX = "FCX",
  LCL = "LCL",
}

export enum FileStatus {
  UPLOADED = "uploaded",
  ERROR = "error",
  CSV_UPLOADED = "csvUploaded",
  WAITING_UPDATE = "waitingUpdate",
  SHIPEEZI_DEFAULT = "shipeeziDefault",
}

export enum WarehousingTabs {
  STORAGE_BOXEX_AND_UNITS = "Storage Boxes & Units",
  MOVEMENT = "Movement",
  TRANSSHIPMENT = "Transshipment",
  STORAGE_ACCOUNTS = "Storage accounts",
}

export enum CarrierTdType {
  BK = "BK",
  BL = "BL",
  CN = "CN",
}

export enum CarrierType {
  AIR = "Air",
  SEA = "Sea",
}

export enum ShipmentLoadType {
  BOX = "Box",
  CASE = "Case",
  PALLET = "Pallet",
  FTL = "FTL",
  LTL = "LTL",
  GROUPAGE_VANLINE = "Groupage/Vanline",
  GROUPAGE = "Groupage",
  FCL = "FCL",
  LCL = "LCL",
  RORO = "RORO",
  BULK = "Bulk",
  OTHER = "Other",
  ULD_PALLETS = "ULD Pallets",
  ULD_CONTAINERS = "ULD Containers",
}

export enum ShipmentServiceType {
  REGULAR_CARGO = "Regular cargo",
  HAZARDOUS_CARGO = "Hazardous cargo",
  FOOD_GRADE_CARGO = "Food grade cargo",
  RARE_CARGO = "Rare cargo",
  REEFER_CARGO = "Reefer cargo (Refrigerated)",
}

export enum MarineEventsStatus {
  COMPLETED = "completed",
  PLANNED = "planned",
  IN_PROGRESS = "in progress",
  CANCELLED = "cancelled",
}

export enum EmailtTemplateTagsEnum {
  COMPANY_TAG = "#TAG_COMPANY",
  COMPANY_TAG_NAME = "#TAG_COMPANY_NAME",
  QUOTE_REFERENCE_TAG = "#TAG_QUOTE_REFERENCE",
  CUSTOMER_NAME_TAG = "#TAG_CUSTOMER_NAME",
  CONSULTANT_NAME = "#TAG_CONSULTANT_NAME",
  REFERENCE_TAG = "#TAG_REFERENCE",
}

export enum ShipmentObjects {
  SHIPMENT = "shipment",
  CONTAINERS = "containers",
  MILESTONES = "milestones",
  PURCHASE_ORDERS = "purchaseOrders",
  CARTONS = "cartons",
  DOCUMENTS = "documents",
}

export enum NotifyPartyOptions {
  ORIGIN_AGENT = "Origin Agent",
  DESTINATION_AGENT = "Destination Agent",
  CUSTOMER = "Customer",
  CONSIGNEE = "Consignee",
  SHIPPER = "Shipper",
  OTHER_PARTY = "Other / Additional party",
}

export enum RequestEscalationNotify {
  MOVE_COORDINATOR = "coordinator",
  CONSULTANT = "consultant",
  MANAGER = "manager",
}

export enum EventTypeCode {
  CONTAINER_LOAD_PORT_OF_LOAD = "CLL",
  CONTAINER_LOAD_TRANSHIPMENT = "CLT",
  CONTAINER_GATE_IN = "CGI",
  DEPARTED = "DEP",
  ARRIVAL = "ARR",
}

export enum IconTypeEnum {
  HOME = "home",
  PACKAGE = "package",
  TRUCK = "truck",
  PORT = "port",
  WAITING = "waiting",
}

export enum SplitableWordsEnum {
  AT = "at",
  FROM = "from",
  TO = "to",
}

export enum StatusBadgeEnum {
  ACTIVE = "active",
  INACTIVE = "inactive",
  DISABLED = "disabled",
  INVITE_EXPIRED = "Invite expired",
  INVITATION_SENT = "Invitation sent",
  PENDING_ACCEPTANCE = "pending accept",
  DELETED = "deleted",
  LOADED = "loaded",
  PARTLY_LOADED = "partly loaded",
  DELIVERED = "delivered",
  PACKED = "packed",
  BOOKED = "booked",
  RECEIVED = "received",
  STARTED = "started",
  UNLOADED = "unloaded",
  LATE = "late",
  FINISHED = "finished",
  IN_TRANSIT = "in transit",
  IN_PROGRESS = "in progress",
  CANCELLED = "cancelled",
  PLANNED = "planned",
  DRAFT = "draft",
  DEACTIVATED = "deactivated",
  REJECTED = "rejected",
  COMPLETED = "completed",
  MFA_ENABLED = "MFA Enabled",
}

export enum AppType {
  CUSTOMER_PORTAL,
  DEFAULT,
}

export enum ShareNotificationId {
  SHARE_SHIPMENT_EMAIL = "share-shipment-email",
  SHARE_SHIPMENT_SMS = "share-shipment-sms",
  SEND_SHIPMENT_EMAIL = "send-shipment-email",
}

export enum TabItem {
  ESTIMATE = "estimate",
  DATE = "date",
  TASKS = "tasks",
}

export enum SummaryOptions {
  TOTAL_WEIGHT = "totalWeight",
  VOLUMETRIC_WEIGHT = "volumetricWeight",
  GROSS_VOLUME = "grossVolume",
}

export enum ShipmentTrackingColumnType {
  AGENT,
  BILL_OF_LADING,
  CONTAINER,
  CARRIER,
  VESSEL_NAME,
  VESSEL_TYPE,
  ORIGIN_PORT,
  FINAL_DESTINATION_PORT,
  GROSS_WEIGHT,
  FLIGHT_NUMBER,
  AIRLINE,
  SHIPMENT,
}

export enum ReportDateType {
  ETA_WAREHOUSE = "etaWarehouse", // schedule
  ETA_UNPACK = "etaUnpack",
  ETA_AT_DESTINATION = "estimatedDestination",
  ARRIVAL_AT_DESTINATION = "arrivalAtDestination",
  CREATED_AT = "createdAt",
}

export enum DashboardPeriodOptions {
  TODAY = "today",
  LAST_15_DAYS = "last15Days",
  LAST_MONTH = "lastMonth",
  MONTH_TO_DATE = "monthToDate",
  LAST_YEAR = "lastYear",
  CUSTOM_DATE = "customDate",
  CUSTOM_PERIOD = "customPeriod",
}

export enum CustomerPortalMilestoneStepStatus {
  CANCELLED = "Cancelled",
  COMPLETED = "Completed",
  IN_PROGRESS = "In Progress",
  PENDING = "Pending",
  REJECTED = "Rejected",
  NA = "N/A",
}

export enum UploadCentreUploadLabel {
  SERVICES = "services",
  FLEET = "fleet",
  LIST_OF_MATERIALS = "listOfMaterials",
  ON_FIELD_STAFF = "onFieldStaff",
}

export enum FleetType {
  OPTIONS = "Options",
  TRUCK = "Truck",
  FORKLIFT = "Forklift",
  VAN = "Van",
  UTE = "Ute",
  PRIME_MOVER = "Prime Mover",
}

export enum ServiceSellType {
  NORMAL = "Normal",
  EXTRA = "Extra",
  STORAGE = "Storage",
  ADDITIONAL = "Additional",
  PERCENTAGE = "Percentage",
  PRE_PAYMENT = "Prepayment",
  PACKING_MATERIALS = "Packing Materials",
}

export enum UploadCentreUploadedBy {
  SHIPEEZI_DEFAULT = 1,
  UPLOADED_BY_ONBOARDING = 2,
  UPLOADED_BY_UPLOAD_CENTRE = 3,
}

export enum UploadCentreItemName {
  SERVICE = "service",
  FLEET = "fleet",
  MATERIAL = "material",
  STAFF = "staff",
}

export enum UploadCentreColumnType {
  STRING = "string",
  NUMBER = "number",
  BOOLEAN = "boolean",
  DATE = "date",
  FLEET_ID = "fleetId",
  BRANCH_CODE = "branchCode",
  WAREHOUSE_CODE = "warehouseCode",
  CODE = "code",
}

export enum ShipperType {
  CONSIGNEE = "Consignee",
  SUPPLIER = "Supplier",
}

export enum MilestonesActualTranslateKey {
  actualDepartureDate = "departure",
  actualAtDepartureDock = "actualAtDepartureDock",
  actualArrivalOfDestination = "actualArrivalOfDestination",
}

export enum MilestonesEstimatedTranslateKey {
  estimatedTimeOfDeparture = "estimateTimeOfDeparture",
  estimatedTimeOfArrival = "estimateTimeOfArrival",
}

export enum MilestonesDefaultTasksTitles {
  initialRequest = "Initial request",
  survey = "Survey",
  tasks = "Tasks",
  completed = "Completed",
}

export enum MilestonesStep {
  delivery = "Delivery",
}

export enum MilestonesStepDetails {
  current = "Current",
}

export enum ActivitiesDateFilters {
  ALL_TIME = "allTime",
  TODAY = "today",
  LAST_WEEK = "lastWeek",
  LAST_MONTH = "lastMonth",
}

export enum ActivitiesTypeValues {
  EDITED = "Edited",
  MOVEMENT = "Movement",
  LOAD = "Load",
  UNLOAD = "Unload",
}

export enum ItemProGearBelongsTo {
  MEMBER = "member",
  SPOUSE = "spouse",
}

export enum Placement {
  end = "end",
  start = "start",
  top = "top",
  bottom = "bottom",
}

export enum CustomerPortalCardTypes {
  QUOTES = "quotes",
  ORDERS = "orders",
  COMMUNICATIONS = "communications",
  SCHEDULES = "schedules",
  ATTENTION = "attention",
}

export enum SealPictureBelongsGroup {
  SPECIAL_ITEMS = "special items",
  CAULKED = "caulked",
  PACKED_AND_SEALED = "packed and sealed",
}

export enum ChecklistSealPictureStatus {
  UPLOADING_PICTURES = "uploading_pictures",
  FAILED_PICTURES = "failed_pictures",
  UPLOADED_PICTURES = "uploaded_pictures",
}

export enum ChecklistSealStatus {
  PROCESSING = "processing",
  DONE = "done",
  FAILED = "failed",
}

export enum MembersType {
  STAFF = "Staff",
  USER = "User",
}

export enum ResourceViewerOptions {
  ORDER = "order",
  TEAM = "team",
}

export enum AvailabilityStatus {
  CANCELLED = "Cancelled",
  COMPLETED = "Completed",
  IN_PROGRESS = "In Progress",
  PENDING = "Pending",
}

export enum OrderVipTreatmentMode {
  NONE = "",
  VIP = "VIP",
  BLUEBARK = "BLUEBARK",
  SAFETY = "SAFETY",
}

export enum OrderTransportationTypeMode {
  ASSISTANCE = "Assistance",
  DOOR_TO_DOOR = "Door to Door",
  DOOR_TO_PORT = "Door to Port",
  DOOR_TO_WAREHOUSE = "Door to Warehouse",
  FOT_RESIDENCE = "FOT Residence",
  PORT_TO_DOOR = "Port to Door",
  PORT_TO_PORT = "Port to Port",
  PORT_TO_WAREHOUSE = "Port to Warehouse",
  WAREHOUSE_TO_DOOR = "Warehouse to Door",
  WAREHOUSE_TO_PORT = "Warehouse to Port",
  WAREHOUSE_TO_WAREHOUSE = "Warehouse to Warehouse",
}

export enum AccountType {
  PRIVATE = "Private",
  CORPORATE = "Corporate",
}

export enum BusEventNames {
  DESPATCH_ON_SUCCESS_CANCEL_TASK = "despatch:onSuccessCancelTask",
  DESPATCH_ON_SUCCESS_CREATE_COMMENT = "despatch:onSuccessCreateComment",
  DESPATCH_ON_SUCCESS_DELETE_COMMENT = "despatch:onSuccessDeleteComment",
  DESPATCH_ON_SUCCESS_UPDATE_TIME = "despatch:onSuccessUpdateTime",
  DESPATCH_ON_SUCCESS_CREATE_CREATE_SINGLE_USE_BOX = "despatch:onSuccessCreateSingleUseBox",
  DESPATCH_ON_SUCCESS_CREATE_TASK = "despatch:onSuccessCreateTask",
  DESPATCH_ON_SUCCESS_CREATE_PLACEHOLDER_TASK = "despatch:onSuccessCreatePlaceholderTask",
  DESPATCH_ON_SUCCESS_DELETE_PLACEHOLDER_TASK = "despatch:onSuccessDeletePlaceholderTask",
  DESPATCH_ON_SUCCESS_UPDATE_TASK = "despatch:onSuccessUpdateTask",
  DESPATCH_ON_SUCCESS_CREATE_CREW = "despatch:onSuccessCreateCrew",
}

export enum OwnershipTypes {
  SUBCONTRACTOR = "subcontractor",
  OWN = "own",
}

export enum ViewPerspective {
  TASK = "tasks",
  TEAM = "teams",
}

export enum CertificationType {
  STANDARD = "Standard",
  VIP = "VIP",
  MILITARY = "Military",
}

export enum DispatchReportType {
  CREW_SCHEDULE_REPORT = "crew_schedule_report",
  WAREHOUSE_SCHEDULE_REPORT = "warehouse_schedule_report",
}

export enum EmailTemplates {
  SEND_ESTIMATE = "Send estimate",
}

export enum TimeSlotType {
  VARIABLE = "variable",
  FIXED = "fixed",
  NONE = "no",
}

export enum TextLogicOption {
  IS = "is",
  IS_NOT = "is_not",
  CONTAINS = "contains",
}

export enum NumberLogicOption {
  IS = "is",
  IS_NOT = "is_not",
  IS_LESSER_THAN = "is_lesser_than",
  IS_GREATER_THAN = "is_greater_than",
}

export enum SingleLogicOption {
  IS = "is",
  IS_NOT = "is_not",
}

export enum MultipleLogicOption {
  SELECTED = "selected",
  NOT_SELECTED = "not_selected",
}

export enum ItemCharacteristicsFilter {
  HARDWARE_BOX = "Hardware box",
  HIGH_RISK_HIGH_VALUE = "High Risk/High value",
  PRO_GEAR = "Pro-Gear",
  ME = "M&E",
}

export enum PhotosFilter {
  HAS_PHOTOS = "Has photos",
  NO_PHOTOS = "No photos",
}

export enum ConditionFilter {
  HAS_CONDITION = "Has Condition",
  NO_CONDITION = "No Condition",
}

export enum MEChecklistFilter {
  DONE = "Done",
  NOT_DONE = "Not Done",
}

export enum WarehouseEquipmentType {
  FLEET = "FLEET",
  GENERAL = "GENERAL",
}

export enum UserDateFormatOptions {
  DD_MM_YYYY = "DD_MM_YYYY",
  MM_DD_YYYY = "MM_DD_YYYY",
}

export enum UserTimeFormatOptions {
  TWENTY_FOUR_HOUR = "24_HOUR",
  TWELVE_HOUR = "12_HOUR",
}
